import { SphereDropdownSelector } from "@components/common/dropdown/sphere-dropdown-selector";
import { neutral } from "@flat-ui";
import { Box, Grid2 } from "@mui/material";
import { selectedProjectChartTimeFrameSelector } from "@store/analytics/analytics-selector";
import { setSelectedProjectChartTimeFrame } from "@store/analytics/analytics-slice";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { TIME_FRAMES, TimeFrameItem } from "@utils/time-utils";

/** Renders the controller for the chart in the project overview page */
export function ProjectChartController(): JSX.Element {
  const dispatch = useAppDispatch();
  const selectedTimeFrame = useAppSelector(
    selectedProjectChartTimeFrameSelector
  );

  function handleTimeFrameChange(value: TimeFrameItem["value"]): void {
    dispatch(setSelectedProjectChartTimeFrame(value));
  }

  return (
    <Grid2 container justifyContent="space-between" marginBottom="24px">
      {/* Chart type selector
          Currently we are only showing one chart type, so we can remove the toggle button group
          If needed, you can use ToggleGroup to render the chart type selector */}
      <Grid2
        sx={{
          alignItems: "center",
          display: "flex",
          color: neutral[800],
          fontSize: "14px",
          fontWeight: "700",
          lineHeight: "20px",
        }}
      >
        Total 360° images
      </Grid2>

      {/* Chart time frame selector */}
      <Grid2>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Box
            sx={{
              fontWeight: "bold",
              marginRight: "10px",
            }}
          >
            Date Range:
          </Box>
          <SphereDropdownSelector
            items={TIME_FRAMES}
            currentValue={selectedTimeFrame}
            handleChange={handleTimeFrameChange}
            menuPosition={{
              anchorOrigin: { vertical: "bottom", horizontal: "left" },
              transformOrigin: { vertical: "top", horizontal: "left" },
            }}
            sxMenu={{
              "& .Mui-selected": {
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.08) !important",
                },
              },
            }}
          />
        </Box>
      </Grid2>
    </Grid2>
  );
}
